import { useEffect } from "react";

const useGoogleMaps = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const apiKey= "AIzaSyBg8bhJnUaTelc-IyKQ41sLQE9GpqvYzkE";
    // script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
};
export default useGoogleMaps;
